import { store, itiHttpService} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { FileInfo } from '@/shared/dtos/fileInfo';

@Module({
  namespaced: true,
  name: 'FileModule',
  store,
  dynamic: true,
})
class FileModule extends VuexModule {

    public lastFiles: FileInfo[] = [];
    public filePath: any = {path: '', ambitId: ''};

    @Mutation
    public setLastFilesFromUser(lastFiles: FileInfo[]) {
        this.lastFiles = lastFiles;
    }

    @Action
    public async getLastFilesFromUser() {
        const res = await itiHttpService.get(API.fileManager + '/GetLastFilesFromUser');
        this.context.commit('setLastFilesFromUser', res);
    }

    @Mutation
    public setLastFilesFromUserByAreaType(lastFiles: FileInfo[]) {
        this.lastFiles = lastFiles;
    }

    @Action
    public async getLastFilesFromUserByAreaType(type: number) {
        const res = await itiHttpService.get(API.fileManager + '/GetLastFilesFromUserByAreaType?typeId=' + type);
        this.context.commit('setLastFilesFromUserByAreaType', res);
    }
    
    @Mutation
    public setLastFilesByAmbitId(lastFiles: FileInfo[]) {
        this.lastFiles = lastFiles;
    }

    @Action
    public async getLastFilesByAmbitId(ambitId: number) {
        const res = await itiHttpService.get(API.fileManager + '/GetLastFilesByAmbitId?ambitId=' + ambitId);
        this.context.commit('setLastFilesByAmbitId', res);
    }

    @Mutation
    public setPath(array: any) {
        this.filePath.path = array[0];
        this.filePath.ambitId = array[1];
    }

    @Action
    public async setFileToShow(e: any) {
        const res = await itiHttpService.get(API.fileManager + '/GetPath' + '?id=' + e.id, false, false, false);
        this.context.commit('setPath', [res,e.ambitId]);
    }


}
export default getModule(FileModule);
